import { createSelector } from "reselect";
import { RootState } from "../../types/store";

const getSocketState = ({ socket }: RootState) => socket;

export const socketSelector = createSelector([getSocketState], (socket) => socket);
